module.exports = __webpack_public_path__ + "img/icon_design.9588fef1.png";